import { useState, useRef, useEffect } from 'react';
import { getData, postData } from "../../../../../ApiServices/ApiService";
import { ORG_TODO_LIST_ADDONS } from '../../../../../ApiServices/BaseURL';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../../../../GlobalContext/GlobalContext';

const ToDoListController = ()=>{

    const location = useLocation();
    const { setIsLoginPopup } = useTheme();
    const [activeToDoLoading, setActiveToDoLoading] = useState(false);
    const [activeToDoError, setActiveToDoError] = useState('');
    const [activeToDoList, setActiveToDoList] = useState([]);
    // useEffect(() => {
    //     fetchActiveToDoItemsList();
    //     fetchExpiredToDoItemsList();
    // }, [])

    useEffect(() => {
        if (location?.state && location.state?.source) {
            //  From Dashboard
            const { source, status } = location?.state;
            console.log('status in todo contoller', status)
                fetchActiveToDoItemsList({ source });
                fetchExpiredToDoItemsList({ source });

        } else {
            //  Direct access — show all users’ todos
            fetchActiveToDoItemsList({  source: null });
            fetchExpiredToDoItemsList({ source: null });
        }
    }, [location.state]);
    
    const fetchActiveToDoItemsList = async ({ source = null } = {}) => {

        try {
            setActiveToDoLoading(true);
            setActiveToDoError('')
            setActiveToDoList([])
            // setTeamInfo({});
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload={
                emp_id_auth: storedUserInfo?.emp_id,
                sc_list_status: "Active",
                action_type: "sc_list"
              }
            if (source) payload.source = source;
            console.log("active todo payload",payload )
            // Make the API call
            const response = await postData(ORG_TODO_LIST_ADDONS, payload);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setActiveToDoList(responseData?.dataJ);
                        } else {
                            setActiveToDoError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setActiveToDoError(responseData?.info || 'Failed to fetch Team Information. Please try again.');
                    }
                } else {
                    setActiveToDoError(responseData?.info || 'Failed to fetch Team Information.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setActiveToDoError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setActiveToDoError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setActiveToDoError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setActiveToDoError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setActiveToDoError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Team Information. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setActiveToDoError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setActiveToDoError(`Failed to fetch Team Information. Please check your network connection and try again.`);
            }
        } finally {
            setActiveToDoLoading(false);
        }
    }

    const [completedToDoLoading, setCompletedToDoLoading] = useState(false);
    const [completedToDoError, setCompletedToDoError] = useState('');
    const [completedToDoList, setCompletedToDoList] = useState([]);
    const fetchExpiredToDoItemsList = async ({ source = null } = {}) => {

        try {
            setCompletedToDoLoading(true);
            setCompletedToDoError('')
            setCompletedToDoList([])
            // setTeamInfo({});
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload={
                emp_id_auth: storedUserInfo?.emp_id,
                sc_list_status: "Expired",
                action_type: "sc_list"
              }
              if (source) payload.source = source;
              console.log("expired todo payload",payload )
            // Make the API call
            const response = await postData(ORG_TODO_LIST_ADDONS, payload);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setCompletedToDoList(responseData?.dataJ);
                        } else {
                            setCompletedToDoError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setCompletedToDoError(responseData?.info || 'Failed to fetch Team Information. Please try again.');
                    }
                } else {
                    setCompletedToDoError(responseData?.info || 'Failed to fetch Team Information.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setCompletedToDoError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setCompletedToDoError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
                setIsLoginPopup(true)
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setCompletedToDoError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setCompletedToDoError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setCompletedToDoError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Team Information. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setCompletedToDoError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setCompletedToDoError(`Failed to fetch Team Information. Please check your network connection and try again.`);
            }
        } finally {
            setCompletedToDoLoading(false);
        }
    }

    return{
        completedToDoList,
        completedToDoError,
        completedToDoLoading,
        setCompletedToDoLoading,
        setCompletedToDoError,
        setCompletedToDoList,

        activeToDoList,
        activeToDoError,
        activeToDoLoading,
        setActiveToDoLoading,
        setActiveToDoError,
        setActiveToDoList,

        fetchExpiredToDoItemsList,
        fetchActiveToDoItemsList
    }

}

export default ToDoListController